import { getAllItems } from "$lib/services/philatelic_items";

export const downloadAllItems = async (token: string, helperElement: Element = document.body) => {
  let a: HTMLAnchorElement | null = null;
  let url: string | null = null;
  try {
    const items = await getAllItems(() => Promise.resolve(token));
    const json = JSON.stringify(items);
    // Setup
    const blob = new Blob([json], { type: "application/json" });
    url = URL.createObjectURL(blob);
    a = document.createElement("a");
    a.href = url;
    a.download = "data.json";
    helperElement.appendChild(a);
  }
  catch (e: any)
  {
    alert(`Error while exporting all philatelic items. ${e.message || "Unknown Error"}`);
    return;
  }
  // Start download
  a.click();
  // Clean up
  helperElement.removeChild(a);
  URL.revokeObjectURL(url);
}